import React from 'react';

import Header from '../partials/Header';
import HeroCubicus from '../partials/HeroCubicus';
import CubicusComponent from '../partials/CubicusComponent';
import Process from '../partials/Process';
import Cta from '../partials/Cta';
import Footer from '../partials/Footer';

function Cubicus() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">

        {/*  Page sections */}
        <HeroCubicus />
        <CubicusComponent/>
        <Process />
        <Cta />

      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default Cubicus;